/**
 * Dashboard translations
 * Main dashboard UI text
 */

import { LANGUAGES } from '../config';

export const dashboardTranslations = {
  [LANGUAGES.EN]: {
    title: 'Esccot Competency Analyzer',
    subtitle: 'Extract competencies from CVs, skills from job postings, and research companies',
    selectUser: 'Select User',
    you: '(You)',
    poweredBy: 'Powered by Autobot',
    cvAnalyzer: 'CV Analyzer',
    cvDescription: 'Extract competencies from your CV',
    viewCVCompetencies: 'View {name}\'s CV competencies',
    analyzeCV: 'Analyze CV',
    viewCV: 'View CV',
    jobAnalyzer: 'Job Analyzer',
    jobDescription: 'Extract required skills from job postings',
    viewJobSkills: 'View {name}\'s job skills',
    analyzeJob: 'Analyze Job Posting',
    companyResearch: 'Company Research',
    companyDescription: 'Research companies and generate comprehensive reports',
    researchCompany: 'Research Company',
    viewCompanyResearch: 'View Company Research',
    trainingRecommendations: 'Training Recommendations',
    trainingDescription: 'Get personalized training recommendations based on your CV and job postings',
    getTrainingRecommendations: 'Get Training Recommendations',
    viewTrainingRecommendations: 'View training recommendations for {name}',
    // Legacy keys - keeping for backward compatibility
    myProfile: 'My Profile',
    teamManagement: 'Team Management',
    systemSettings: 'System Settings',
    adminDashboard: 'Admin Dashboard',
    uploadCV: 'Upload CV',
    uploadJob: 'Upload Job',
    viewResults: 'View Results',
    notifications: 'Notifications',
    stats: 'Statistics',
    lastUpdated: 'Last Updated',
    viewAll: 'View All'
  },
  [LANGUAGES.FR]: {
    title: 'Analyseur de Compétences Esccot',
    subtitle: 'Extraire les compétences des CV, les compétences des offres d\'emploi et rechercher des entreprises',
    selectUser: 'Sélectionner un utilisateur',
    you: '(Vous)',
    poweredBy: 'Alimenté par Autobot',
    cvAnalyzer: 'Analyseur de CV',
    cvDescription: 'Extraire les compétences de votre CV',
    viewCVCompetencies: 'Voir les compétences CV de {name}',
    analyzeCV: 'Analyser le CV',
    viewCV: 'Voir le CV',
    jobAnalyzer: 'Analyseur d\'Emploi',
    jobDescription: 'Extraire les compétences requises des offres d\'emploi',
    viewJobSkills: 'Voir les compétences d\'emploi de {name}',
    analyzeJob: 'Analyser l\'offre d\'emploi',
    companyResearch: 'Recherche d\'Entreprise',
    companyDescription: 'Rechercher des entreprises et générer des rapports complets',
    researchCompany: 'Rechercher une entreprise',
    viewCompanyResearch: 'Voir la recherche d\'entreprise',
    trainingRecommendations: 'Recommandations de Formation',
    trainingDescription: 'Obtenez des recommandations de formation personnalisées basées sur votre CV et les offres d\'emploi',
    getTrainingRecommendations: 'Obtenir des recommandations de formation',
    viewTrainingRecommendations: 'Voir les recommandations de formation pour {name}',
    // Legacy keys - keeping for backward compatibility
    myProfile: 'Mon Profil',
    teamManagement: 'Gestion d\'Équipe',
    systemSettings: 'Paramètres Système',
    adminDashboard: 'Tableau de Bord Admin',
    uploadCV: 'Télécharger CV',
    uploadJob: 'Télécharger Emploi',
    viewResults: 'Voir Résultats',
    notifications: 'Notifications',
    stats: 'Statistiques',
    lastUpdated: 'Dernière mise à jour',
    viewAll: 'Voir tout'
  }
};
